module.exports = __webpack_public_path__ + "static/media/20.b39170d9.png";